import React from "react";
import {HierarchyTreeItemDetailDto} from "../service/HierarchyTreeItemDetailDto";
import {_transl} from "../../../../../store/localization/TranslMessasge";
import Typography from "@mui/material/Typography";
import {ColorDto, Colors} from "../../../../../common/apis/Color";
import Constants from "../../../../../common/Constants";
import {FolderTreeDataDto} from "../service/HierarchyTreeDataDto";
import {ICON_REGISTRY, IconName} from "../dialogs/Icons";

export interface FolderTreeItemLabelProps {
    treeItem: HierarchyTreeItemDetailDto;
}

export function FolderTreeItemLabel(props: FolderTreeItemLabelProps) {
    const {treeItem} = props;

    const folderData = (treeItem.treeData as FolderTreeDataDto | undefined);

    const color = resolveColor(folderData?.color);
    const SelectedIcon = resolveIcon(folderData?.icon);

    function resolveIcon(icon?: string) {
        const key = icon as IconName | undefined;
        return (key && ICON_REGISTRY[key]) ? ICON_REGISTRY[key] : ICON_REGISTRY.folder;
    }

    function resolveColor(color?: ColorDto) {
        return color ? Colors.toCss(color) : Constants.MODEL_FOLDER_ICON_COLOR;
    }

    function formatTitle(treeItem: HierarchyTreeItemDetailDto): string {
        if (treeItem.title === undefined) {
            return "";
        } else {
            return treeItem.translateTitle ? _transl(treeItem.title) : treeItem.title
        }
    }

    return (
            <>
                <Typography component={"span"} sx={{color: color, marginRight: 1, display: "flex", alignItems: "center"}}>
                    <SelectedIcon/>
                </Typography>
                <Typography component={"span"} sx={{display: "flex", alignItems: "center"}}>
                    {formatTitle(treeItem)}
                </Typography>
            </>
    );
}